import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 1 }

import { legacyLogicalPropertiesTransformer } from 'ant-design-vue';
import { provide, ref, onMounted, onUnmounted } from 'vue'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import cloneDeep from 'lodash/cloneDeep'
import Main from '@/views/main/index.vue'
import Login from '@/views/login/index.vue'
import TipModal from '@/components/tip.vue'
import { routerList } from '@/router'
import { getHostInfo } from '@/api/main'
// import CustomerService from '@/views/components/customerService.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const scrollToTop = () => window.scrollTo(0, 0);

onMounted(() => {
  // 当前路由变化时滚动到顶部
  router.afterEach(() => {
    scrollToTop();
  });
});

onUnmounted(() => {
  // 组件销毁时移除路由的监听
  router.afterEach(null);
});


// NProgress.configure({ showSpinner: false })
NProgress.configure()
dayjs.locale('zh-cn')

// const router = useRouter()
const store = useStore()
const loading = ref(true)

const getHostData = async () => {
  try {
    const res: any = await getHostInfo()
    // const res = await Promise.resolve({ res: { operatorType: 'SITE'} })
    if (res.res) {
      store.commit('setMainInfo', res.res)
    }
    return res
  } catch(e) {
    return {}
  }
}

const addRoutes = async () => {
  const res: any = await getHostData()
  if (res.res?.operatorType) {
    const role = res.res.operatorType
    let list = cloneDeep(routerList)?.map((route) => {
      // 判断AST.NET/脚本错误页
      if (!res.res.specInfo?.language?.includes('NET') && route.name === 'hostEnvSet') {
        let children = route.children.filter((r) => r.name !== 'hostEnvSetDNet')
        children = children.filter((r) => r.name !== 'hostEnvSetErrorInfo')
        return ({ ...route, children })
      }
      // 判断外贸版才展示cdn
      if ((!res.res.specInfo?.productType?.includes('foreignTrade') || res.res.instanceType?.includes('OLD')) && route.name === 'domainCertCdn') {
        const children = route.children.filter((r) => r.name !== 'cdn')
        route.meta.title = '域名/证书'
        return ({ ...route, children })
      }
      if(res.res?.specInfo.plugin === 0 && route.name === 'tool'){
        const children = route.children.filter((r) => r.name !== 'plugInManager')
        return ({ ...route, children })
      } else if(res.res?.specInfo.plugin === 1 && route.name === 'tool') {
        route.meta.new = true
        const children = route.children.filter((r) => {
          if(r.name == 'plugInManager') {
            r.meta.new = true
            return r
          } else {
            return r
          }
        })
        return ({ ...route, children })
      }
      return route
    })
    // 只有由虚机升级创建且服务端登录态明确携带转换归属的共享站点才展示迁移记录。
    if (!res.res.hostingConversionRecordAvailable) {
      list = list.filter((route) => route.name !== 'hostingConversion')
    }
    // if(res.res.apacheFlag){
    //   // 判断老虚机不展示域名证书
    //   list = list.filter((route) => {
    //      if(route.path !== '/domainCertCdn') {
    //         return ({ ...route })
    //       }
    //   })
    // }
    if(res.res.hostService.serviceStatus.value == 'BLOCKING'){
      // 已到期状态限制路由
      list = list.filter((route) => {
          if(route.path == '/backup') {
            return ({ ...route })
          } else if(route.path == '/domainCertCdn') {
             route.children = route.children.filter((r) => r.name !== 'cdn')
            return ({ ...route })
          }
      })
    }
    store.commit('getMenuList', { role, list })
    Xinnet.util.getPermissionMenus?.(list, role)?.forEach((route) => {
      router.addRoute(route)
    })
    return true
  }
  return false
}

const register = ref(false)
router.beforeEach(async (to, from, next) => {
  NProgress.start()
  const logged = store.state.hostInfo.operatorType
  if (to.path === '/login') {
    // 已登录返回当前页
    if (logged) {
      next({ ...from, replace: true })
    } else {
      // 登出
      next()
      register.value = false
      loading.value = true
    }
  } else {
    if (register.value) {
      next()
    } else {
      loading.value = true
      // 首次添加动态路由
      const res = await addRoutes()
      // 接口正常返回数据
      if (res) {
        next({ ...to, replace: true })
        register.value = true
      } else {
        next()
      }
      loading.value = false
    }
  }
  NProgress.done()
})

provide('getHostData', getHostData)

return (_ctx: any,_cache: any) => {
  const _component_a_config_provider = _resolveComponent("a-config-provider")!
  const _component_a_style_provider = _resolveComponent("a-style-provider")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_a_style_provider, {
    hashPriority: "high",
    transformers: [_unref(legacyLogicalPropertiesTransformer)]
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_config_provider, {
        locale: _unref(zhCN),
        theme: {
        token: {
          borderRadius: 4,
          controlHeight: 32,
          colorPrimary: _ctx.$settings.globalColor.primary,
          colorSuccess: _ctx.$settings.globalColor.success,
          colorWarning: _ctx.$settings.globalColor.warning,
          colorError: _ctx.$settings.globalColor.error,
        }
      }
      }, {
        default: _withCtx(() => [
          (_ctx.$route.path.startsWith('/login'))
            ? (_openBlock(), _createBlock(Login, { key: 0 }))
            : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Main)
              ])), [
                [_directive_loading, loading.value]
              ]),
          _createVNode(TipModal)
        ]),
        _: 1
      }, 8, ["locale", "theme"])
    ]),
    _: 1
  }, 8, ["transformers"]))
}
}

})